import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Input, Switch } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';
import { AssociateHours } from '../../../../../../components/Routes/Associates/AddAssociate/associate-hours';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const WorkSchedule = ({ form, associateId, storeOptions }) => {
  const outOfOfficeEnabled = Form.useWatch('outOfOfficeEnabled', form);
  console.log(outOfOfficeEnabled)
  return (
    <SettingsContent
      icon={<FontAwesomeIcon icon={['far', 'lock']} />}
      title="Work Schedule"
      description="Manage your regular work schedule. This will be used when scheduling appointments and for out of office response."
      contentClassName="w-100-P"
    >
      <AssociateHours associateId={associateId} storeOptions={storeOptions} />
      <DescriptionBox
        className="w-100-P"
        style={{ marginBottom: 8, marginTop: 24 }}
        title="Out of Office response"
        description="Send a response to any inbound message from an assigned client, regardless of store. If you are working in
              any location, the message will not go out."
        input={
          <Form.Item name="outOfOfficeEnabled" valuePropName="checked" style={{ marginBottom: 0 }}>
            <Switch />
          </Form.Item>
        }
      />
      <Form.Item name="outOfOfficeResponse" className="w-100-P m-top-0">
        <Input.TextArea
          className="w-100-P"
          disabled={!outOfOfficeEnabled}
          rows={4}
          placeholder="Out of Office response"
        />
      </Form.Item>
    </SettingsContent>
  );
};
